<template>
  <div>
    <div
      class="wrap_content"
    >
      <div class="wrap_content_code">
        <div class="wrap_content_code_box">
          <div class="wrap_content_code_box_left">
            <div class="qr-code-wrap">
            <img class="img" src="@/assets/image/index/qrCode.png" alt="" />
            <div class="qr-code-intro">微信扫一扫，使用小程序</div>
            </div>
            <ul class="ul">
              <li class="li"><span class="text">青岛环境医院</span></li>
              <li class="li">
                <img
                  class="imgL"
                  src="@/assets/image/index/add.png"
                  alt=""
                /><span class="text" alt="地址：山东省青岛市市南区京山路15号"
                  >地址：山东省青岛市市南区京山路15号</span
                >
              </li>
              <li class="li">
                <img
                  class="imgL"
                  src="@/assets/image/index/email.png"
                  alt=""
                /><span class="text">hkyghs1@163.com</span>
              </li>
            </ul>
          </div>
          <div class="wrap_content_code_box_right">
            <ul>
              <li>友情链接</li>
              <li>
                <a href="https://www.mee.gov.cn" target="_blank"
                  ><span class="text">生态环境部</span></a
                >
              </li>
              <li>
                <a
                  href="http://mbee.qingdao.gov.cn/n28356059/index.html"
                  target="_blank"
                  ><span class="text">青岛市生态环境局</span></a
                >
              </li>
              <li>
                <a href="http://www.china-eia.com" target="_blank"
                  ><span class="text">环境影响评价网</span></a
                >
              </li>
            </ul>
            <ul>
              <li>友情链接</li>
              <li>
                <a href="http://sthj.shandong.gov.cn" target="_blank"
                  ><span class="text">山东省生态环境厅</span></a
                >
              </li>
              <li>
                <a
                  href="http://permit.mee.gov.cn/permitExt/defaults/default-index!getInformation.action"
                  target="_blank"
                  ><span class="text">全国排污许可证管理信息平台</span></a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap_footer">
      <span>版权所有©青岛市环境保护科学研究院</span>
      <!-- <span>2022-2023鲁ICP备08085864133</span> -->
      <a href="https://beian.miit.gov.cn" target="_blank"
                  ><span class="text">备案/许可证编号为：鲁ICP备2022016754号</span></a
                >
    </div>
  </div>
</template>
<script>
export default {
  name: "footCode",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
@import url("../../static/style/index.less");
.wrap {
  &_content_code {
    margin: 0em auto 0;
    background: linear-gradient(to right, #3ec5d1, #2786d0, #3ec5d1);
    padding: 0.25em 0;
    &_box {
      width: 12.8em;
      margin: auto;
      padding: 0 0.4em;
      .display_center(space-between);
      align-items: flex-start;
      &_left {
        display: flex;
        align-items: flex-start;
        .img {
          width: 1em;
          height: 1em;
          margin-right: 0.15em;
        }
        ul {
          width: 4em;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          // align-items: center;
          li {
            color: @colorF;
            font-size: 0.1em;
            margin-top: 10px;
            .display_alignItem;
            &:nth-of-type(1) {
              font-size: 0.18em;
              font-weight: bold;
              margin-top: 3px;
            }
            .imgL {
              width: 14px;
              height: 100%;
              margin-right: 8px;
            }
          }
        }
      }
      &_right {
        flex: 1;
        margin-left: 2em;
        display: flex;
        margin-top: 0.05em;
        ul {
          margin-right: 0.5em;
          li {
            color: @colorF;
            font-size: 0.1em;
            margin-top: 4px;
            display: flex;
            align-items: flex-start;
            a {
              color: #fff;
            }
            &:nth-of-type(1) {
              font-size: 0.18em;
              font-weight: bold;
              margin-top: -3px;
            }
            // .text{
            //     .ellipsis;
            // }
          }
          &:nth-last-of-type(1) {
            li:nth-of-type(1) {
              opacity: 0;
            }
          }
        }
      }
    }
  }
  &_footer {
    background: @color3;
    height: 50px;
    color: @colorF;
    font-size: 0.13em;
    .display_center(space-evenly);
    a{
      color: @colorF;
    }
  }
  .qr-code-wrap{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    margin-right: .1rem;
    .img{
      margin: auto;
    }
      .qr-code-intro{
     color: #fff;
     font-size: 0.08em;
     font-weight: 500;
     letter-spacing: 0.1em;
     margin-top: 8px;
  }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/footCode.vue